export const isAgentPath = (pathname) => pathname.includes('/agent/');

export const getPathRoot = (pathname: string) =>
  isAgentPath(pathname) ? pathname.split('/').splice(0, 3).join('/') : '';

export const getAgentFromPath = (pathname: string) =>
  isAgentPath(pathname) ? pathname.split('/').splice(2, 1).join('') : '';
